export const RAFFLE_FAN_PREVIEW_STATES = [
  'entry',
  'submitted',
  'ready-to-draw',
  'drawing-safe',
  'drawing-eliminated',
  'completed-winner',
  'completed-loser',
] as const;

export type RaffleFanPreviewState = (typeof RAFFLE_FAN_PREVIEW_STATES)[number];

export function parseRaffleFanPreviewState(
  value: string | null,
): RaffleFanPreviewState {
  if (
    value &&
    (RAFFLE_FAN_PREVIEW_STATES as readonly string[]).includes(value)
  ) {
    return value as RaffleFanPreviewState;
  }
  return 'submitted';
}
